export const restructureErrorMessage = (error: any) => {
  return (
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    `Operation Failed, ${error.toString()}`
  );
};
